<template>
  <div class="view">
    <div class="content">
      <div class="condition">
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item label="积分类型">
              <el-select v-model="formdata.type" placeholder="请选择退款类型" size="small">
                <el-option
                  v-for="item in type_list"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>            
            <el-form-item label="访客昵称">
              <el-input v-model="formdata.visitor_name" placeholder="请搜索访客昵称" size="small"></el-input>
            </el-form-item>
            <el-form-item label="派发人昵称">
              <el-input v-model="formdata.sender" placeholder="请搜索派发人昵称" size="small"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search" size="small"></el-button>
            </el-form-item>
          </el-form>
        </div>        
      </div>  
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="访客昵称" prop="nickname"></el-table-column>  
          <el-table-column label="变动类型" prop="type_text"></el-table-column>  
          <el-table-column label="变动后积分" prop="new_points"></el-table-column>  
          <el-table-column label="积分数量">
            <template slot-scope="scope">
              <span :class="scope.row.add_del=='-'?'red':'whd-green'">{{scope.row.change_points}}</span>
            </template>
          </el-table-column>  
          <el-table-column label="时间" prop="time_text"></el-table-column>  
          <el-table-column label="明细描述" prop="desc"></el-table-column>  
        </el-table> 
      </div>   
      <div class="pag_wrap">
        <el-pagination
          background
          @current-change="pageIndexChange"
          :page-size="page.pagesize"
          :current-page="page.pageindex"
          layout="total, prev, pager, next"
          :total="page.total"
        ></el-pagination>
      </div>      
    </div>  
  </div>  
</template>

<script>
import api from "@/api.js";
import aftersalesDetailDialog from "@/components/dialog/aftersalesDetailDialog.vue";
import { pagination } from "@/util/util.js";
export default {
  name: 'integralDetail',
  data() {
    return {
      formdata: {
        type: '',
        visitor_name: '',
        sender: ''
      },
      type_list: [],
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      }
    }
  },
  mounted() {
    this.initFn(0);
  },
  methods: {
    search() {
      this.page.pageindex = 1;
      this.initFn(1);
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.initFn(1);
    },
    initFn(num) {
      this.formdata.page = this.page.pageindex;
      this.axios
          .post(api.points_integralDetails, this.formdata)
          .then(response => {
            if (response.data.code == 0) {
              if (num === 0) {
                this.type_list = response.data.type_list;
                if (this.type_list.length > 0) {
                  this.type_list.forEach(item => {
                    if (item.act==1) {
                      this.formdata.type = item.value;
                    }
                  })
                }
              }
              this.tableData = response.data.list;
              this.page.total = response.data.all_page;
            } else {
              this.page.total = 0;
            }
          })
          .catch(() => {});
    }
  }
}
</script>
